import * as React from 'react';

import { requestPost } from '../../../../modules/request/index';
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility';
import { ButtonSpinner } from '../../../Shared';
import DemoGuardedButton from '../shared/demoGuardedButton';

interface ArchiveClassModalProps {
  close: () => void;
  onSuccess: (string) => void;
  classroom: any;
}

export const ArchiveClassModal = ({ close, onSuccess, classroom }: ArchiveClassModalProps) => {
  const { modalRef } = useModalAccessibility(close);

  const [processingRequest, setProcessingRequest] = React.useState<boolean>(false)
  const [error, setError] = React.useState<string>(null)

  function unarchive() {
    setProcessingRequest(true)
    setError(null)
    requestPost(`/teachers/classrooms/${classroom.id}/unhide`, null, () => {
      onSuccess('Class un-archived')
      setProcessingRequest(false)
    }, (body) => {
      setProcessingRequest(false)
      setError(body?.errors?.length ? body.errors.join(' ') : 'This class could not be un-archived. Please try again.')
    })
  }
  return (
    <div className="modal-container unarchive-class-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="unarchiveClassModalTitle"
        aria-modal="true"
        className="unarchive-class-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="unarchiveClassModalTitle">Un-archive this class?</h3>
        </div>
        <div className="unarchive-class-modal-text">
          <p>You and your students will have access to this class again. This class will move to the "Active Classes" tab.</p>
        </div>
        {error && <p className="error-text" role="alert">{error}</p>}
        <div className="form-buttons">
          <button className="quill-button outlined green medium focus-on-light" onClick={close}>Cancel</button>
          <DemoGuardedButton className="quill-button contained green medium unarchive-button focus-on-light" onClick={unarchive}>{processingRequest ? <ButtonSpinner variant="light" /> : 'Un-archive'}</DemoGuardedButton>
        </div>
      </div>
    </div>
  )
}

export default ArchiveClassModal
